export const STRIPE_CONFIGURATION_SECTIONS = {
  none: 'none',
  auth: 'auth',
  sync: 'sync',
} as const;

export type StripeConfigurationSections = typeof STRIPE_CONFIGURATION_SECTIONS[keyof typeof STRIPE_CONFIGURATION_SECTIONS];